// extracted by mini-css-extract-plugin
export var icon = "_4h-3";
export var subtitle = "_4h-2";
export var title = "_4h-1";
export var value = "_4h-0";